import CustomRadio from '../../../common/components/CustomRadio';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import CustomTextInput from '../../../common/components/CustomTextInput';
import Tooltip from '../../../common/components/Tooltip';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeOrderFormView2AccountInputFieldName =
  'artist_registration_type'|'artist_registration_mbmail'|
  'artist_registration_password'|'artist_registration_agreement';


/**
 * アカウント情報の入力
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function KaraokeOrderFormView2AccountInput({
  getValue,
  setValue,
  getErrors,
  getWarnings,
} : {
  getValue: (name: KaraokeOrderFormView2AccountInputFieldName) => string,
  setValue: (name: KaraokeOrderFormView2AccountInputFieldName, value: string) => void,
  getErrors: (name: KaraokeOrderFormView2AccountInputFieldName) => FieldValidationErrorsType,
  getWarnings: (name: KaraokeOrderFormView2AccountInputFieldName) => FieldValidationErrorsType,
}) {

  const artistRegistrationTypeOptions = [
    { value: 'signup', title: '持っていない', description: 'Frekul未登録' },
    { value: 'auth', title: '持っている', description: 'Frekul登録済み' },
  ];

  return (
    <>
      <dl>
        <dt>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="about frekul">Frekul IDをお持ちですか？</label>
          <Tooltip message="Frekulはあなたの音楽活動をサポートするWebサービスです。登録料/基本使用料は無料ですのでご安心ください。" />
        </dt>
        <dd>
          <CustomRadio
            options={artistRegistrationTypeOptions}
            value={getValue('artist_registration_type')}
            setValue={(value) => setValue('artist_registration_type', value)}
            validationErrors={getErrors('artist_registration_type')}
          />
        </dd>
      </dl>
      {getValue('artist_registration_type') === 'signup' && (
        <>
          <dl className="sign_up">
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="mailaddress">普段お使いのメールアドレス</label>
            </dt>
            <dd>
              <CustomTextInput
                dataType="email"
                placeholder=""
                value={getValue('artist_registration_mbmail')}
                setValue={(value) => setValue('artist_registration_mbmail', value)}
                validationErrors={getErrors('artist_registration_mbmail')}
                validationWarnings={getWarnings('artist_registration_mbmail')}
              />
            </dd>
          </dl>
          <dl className="sign_up">
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="password">パスワードを決めてください</label>
            </dt>
            <dd>
              <CustomTextInput
                dataType="password"
                placeholder=""
                value={getValue('artist_registration_password')}
                setValue={(value) => setValue('artist_registration_password', value)}
                validationErrors={getErrors('artist_registration_password')}
              />
            </dd>
          </dl>
          <dl>
            <CustomCheckbox
              checked={getValue('artist_registration_agreement') !== '0'}
              setChecked={(checked) => setValue('artist_registration_agreement', checked ? '1' : '0')}
              validationErrors={getErrors('artist_registration_agreement')}
            >
              <a href="/terms" target="_blank">Frekul利用規約</a>
              に同意して登録する
            </CustomCheckbox>
          </dl>
        </>
      )}
      {getValue('artist_registration_type') === 'auth' && (
        <>
          <dl className="sign_up">
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="mailaddress">ログインメールアドレス</label>
            </dt>
            <dd>
              <CustomTextInput
                dataType="email"
                placeholder=""
                value={getValue('artist_registration_mbmail')}
                setValue={(value) => setValue('artist_registration_mbmail', value)}
                validationErrors={getErrors('artist_registration_mbmail')}
              />
            </dd>
          </dl>
          <dl className="sign_up">
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="password">パスワード</label>
            </dt>
            <dd>
              <CustomTextInput
                dataType="password"
                placeholder=""
                value={getValue('artist_registration_password')}
                setValue={(value) => setValue('artist_registration_password', value)}
                validationErrors={getErrors('artist_registration_password')}
              />
            </dd>
          </dl>
        </>
      )}
    </>
  );
}
